import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../../../../components/global/FormGroup';
import Alert from '../../../../../components/global/Alert';
import Button from '../../../../../components/global/Button';
import { getFormikTouchedErrors } from '../../../../../util/formik';

const propTypes = {
  loading: PropTypes.bool,
  values: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email_address: PropTypes.string,
    password: PropTypes.string,
    password_verification: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const EmailRegistrationStep = ({
  loading,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  identityName,
}) => {
  const errorList = Object.values(
    getFormikTouchedErrors(errors, touched) ?? {},
  );

  return (
    <Fragment>
      <h4 className="px-2 mb-4">
        Welcome to Waldo! <br /> Please confirm your identity below to view
        photos{identityName ? ` of ${identityName}` : ''}.
      </h4>
      <form onSubmit={handleSubmit} className="px-2">
        <div className="row">
          <div className="col-lg-6 col-12">
            <FormGroup
              id="first_name"
              name="first_name"
              label="First name"
              placeholder="John"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.first_name}
              required
            />
          </div>

          <div className="col-lg-6 col-12">
            <FormGroup
              id="last_name"
              name="last_name"
              label="Last name"
              placeholder="Smith"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.last_name}
              required
            />
          </div>

          <div className="col-12">
            <FormGroup
              id="email_address"
              name="email_address"
              label="Email Address"
              placeholder="example@email.com"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email_address}
              required
            />
          </div>

          <div className="col-lg-6 col-12">
            <FormGroup
              id="password"
              name="password"
              label="Please Create a password"
              placeholder="Password"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.password}
              type="password"
              required
            />
          </div>

          <div className="col-lg-6 col-12">
            <FormGroup
              id="password_verification"
              name="password_verification"
              label="Verify your password"
              placeholder="Password Verification"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.password_verification}
              type="password"
              required
            />
          </div>
        </div>

        {errorList?.length > 0 && (
          <Alert type="danger" className="mb-4">
            <ul className="mb-0">
              {errorList.map(error => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </Alert>
        )}

        <Button
          type="submit"
          disabled={
            loading ||
            !values.email_address ||
            !values.password ||
            !values.password_verification
          }
          loading={loading}
        >
          {loading ? 'Processing...' : 'Request Verification Email'}
        </Button>

        <div className="mt-4">
          <p className="text-sm">
            By continuing you agree to the{' '}
            <a href="/terms" target="_blank" rel="nofollow">
              Terms of Use
            </a>{' '}
            &{' '}
            <a href="/terms" target="_blank" rel="nofollow">
              Privacy Policy
            </a>
          </p>
        </div>
      </form>
    </Fragment>
  );
};

EmailRegistrationStep.propTypes = propTypes;

export default EmailRegistrationStep;
